module.exports = __webpack_public_path__ + "img/design-the-next-iphone.492fa21c.png";